// 주변 장비 찾기(on-demand discovery) 다이얼로그용 순수 로직 - PROTOCOL.md §2.2a/§2.5(v1.4)의 STATUS/결과 표시.
// EqpAgentDiscoveryDialog에서만 쓰지만, eqpState.js와 같은 이유로 컴포넌트와 분리해서 테스트 가능하게 둔다.

export const STATUS_LABEL = {
  REQUESTED: '요청됨',
  RUNNING: '검색 중',
  DONE: '완료',
  FAILED: '실패',
  EXPIRED: '만료됨(에이전트 응답 없음)',
  CANCEL_REQUESTED: '중지 중...',
  CANCELLED: '중지됨',
};

export const STATUS_COLOR = {
  REQUESTED: 'default',
  RUNNING: 'info',
  DONE: 'success',
  FAILED: 'error',
  EXPIRED: 'warning',
  CANCEL_REQUESTED: 'warning',
  CANCELLED: 'default',
};

// 3초 폴링을 계속해야 하는 상태인지(REQUESTED/RUNNING/CANCEL_REQUESTED) - 그 외(DONE/FAILED/EXPIRED/CANCELLED/없음)는 멈춘다.
export const isPolling = (status) => status === 'REQUESTED' || status === 'RUNNING' || status === 'CANCEL_REQUESTED';

// [중지] 버튼을 보여줄지 - 에이전트가 아직 받아가지 않았거나(REQUESTED) 지금 스캔 중일(RUNNING) 때만.
// CANCEL_REQUESTED는 이미 중지 요청을 보낸 뒤라 버튼을 다시 보여주지 않는다(중복 요청 방지).
export const canCancel = (status) => status === 'REQUESTED' || status === 'RUNNING';

// 진행 상황 문구 - "120/254 스캔 · 3건 발견". totalCnt가 없으면(아직 집계 전/구버전 에이전트) null.
export const formatProgress = (info) => {
  if (!info || info.totalCnt == null) return null;
  const scanned = info.scannedCnt ?? 0;
  const found = info.foundCnt ?? 0;
  return `${scanned}/${info.totalCnt} 스캔 · ${found}건 발견`;
};

// 결과 1행의 "종류" 표시 - FOCAS로 확인됐으면 장비 정보, 포트만 열렸으면 그것만 안내.
export const describeResult = (row) => {
  if (!row) return '';
  if (row.proto === 'FOCAS' && row.detected === 'Y') {
    return `FANUC${row.series ? ` ${row.series}` : ''}${row.version ? ` v${row.version}` : ''}`;
  }
  if (row.proto === 'FOCAS') {
    return 'FOCAS 포트는 열렸지만 장비 확인 안 됨';
  }
  return `${row.proto || 'TCP'} 포트만 열림`;
};

// [등록] 버튼을 보여줄지 - FOCAS로 확인됐고(detected='Y') 아직 등록된 장비가 없을 때만.
export const canRegister = (row) => !!row && row.proto === 'FOCAS' && row.detected === 'Y' && !row.matchedEqpUuid;
